
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormattedDate, FormattedMessage, injectIntl } from 'react-intl'
import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'
import * as quizzesActions from '../../../Quizzes/quizzes.actions'
import { Game } from '../../../../Core/'

import * as tutorialSelectors from '../../../../Tutorial/tutorial.selectors'
import * as firebaseSelectors from '../../../../Core/Firebase/firebase.selectors'
import UserShield from '../../../Components/UserShield'

class BattlesTab extends React.Component {
  msToMinutesAndSeconds(ms) {
    let minutes = Math.floor(ms / 60000)
    let seconds = ((ms % 60000) / 1000).toFixed(0)

    if (seconds == 60) {
      minutes = minutes + 1
      seconds = '00'
    } else if (seconds < 10) {
      seconds = '0' + seconds
    }
    return minutes + ':' + seconds
  }

  componentDidMount() {
    const { getQuestions, getAllDisputes, isTutorialMode } = this.props

    if (isTutorialMode) return
    getQuestions()
    getAllDisputes()
  }

  renderCardBattle() {
    const { startBattle, rivalInfo, addHowlSound } = this.props

    return (
      <div className="mars--challenge__list">
        <div className="box--border">
          <div className="box--border__canvas">
            <div
              onClick={() => {
                startBattle()
                addHowlSound('button_click_icon')
              }}
              className="mars--challenge__list--item"
            >
              <div className="mars--challenge__list--title">
                <FormattedMessage id="phase.newChallenge" />
              </div>
              <UserShield shield={rivalInfo.colonyShield} />
              <div className="mars--challenge__list--subtitle">
                <span>{rivalInfo.colonyName}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderCardNextPhase() {
    return (
      <div className="mars--challenge__list">
        <div className="box--border">
          <div className="box--border__canvas">
            <div className="mars--challenge__list--item">
              <div className="mars--challenge__list--title">
                <FormattedMessage id="phase.noChallenge" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderBoxResume() {
    const { battlesInfo } = this.props

    const totalBattles = battlesInfo.length
    let battlesWon = 0
    let battlesLost = 0
    // let coinsWon = 0
    // let coinsLost = 0
    battlesInfo.map((battle) => {
      if (battle.type === 'BATTLE_WON') {
        battlesWon++
        // coinsWon += battle.coins
      } else {
        battlesLost++
        // coinsLost += battle.coins
      }
    })

    return (
      <div className="box--border">
        <div className="box--border__canvas">
          <div className="mars--challenge__info important">
            <div className="mars--challenge__info--item failed">
              <div className="value">{battlesLost}</div>
              <div className="text">
                <FormattedMessage id="phase.battleTab.battlesLost" />
              </div>
              {/*ul className='info'>
                <li>{ Math.abs(coinsLost) } <span className='icon-coin'/></li>
              </ul>*/}
            </div>
            <div className="mars--arrow__left"> </div>
            <div className="mars--challenge__info--item">
              <div className="value">{totalBattles}</div>
              <div className="text">
                <FormattedMessage id="phase.battleTab.battlesTotal" />
              </div>
            </div>
            <div className="mars--arrow__right"> </div>
            <div className="mars--challenge__info--item success">
              <div className="value">{battlesWon}</div>
              <div className="text">
                <FormattedMessage id="phase.battleTab.battlesWon" />
              </div>
              {/*<ul className='info'>
                <li>{ Math.abs(coinsWon )} <span className='icon-coin'/></li>
              </ul>*/}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderBattleRow(won = true, battle, index) {
    const { playersList, intl, playerID } = this.props

    if (!battle) {
      return null
    }

    const attacker = playersList[battle.attacker]
    const defender = playersList[battle.defender]
    const buildName = intl.formatMessage({ id: `buildings.${battle.buildingName}` })

    return (
      <div key={index} className={`mars--challenges__row ${index > 0 ? 'border' : ''}`}>
        <div className="mars--challenges__col">
          <span className="name">{attacker.colonyName}</span>
          {playerID == battle.attacker ? (
            <span className={`text ${won ? 'darkgreen' : 'red'}`}>
              {battle.winnerId == battle.defender ? (
                <React.Fragment>
                  <FormattedMessage
                    id={`battles.${won ? 'wins' : 'losts'}`}
                    values={{ amount: 10 }}
                  />
                  <span className="icon-coin"></span>
                </React.Fragment>
              ) : (
                <FormattedMessage
                  id={`battles.${won ? 'won' : 'lost'}`}
                  values={{ name: buildName, level: battle.buildingLevel }}
                />
              )}
            </span>
          ) : null}
        </div>
        <div className="mars--challenges__col">
          <span className="result">
            {battle.rightAnswersAttacker ? battle.rightAnswersAttacker : 'N/A'} -
            {battle.rightAnswersDefender ? battle.rightAnswersDefender : 'N/A'}
          </span>
          <span className="time">
            <span>
              {battle.durationAttacker ? (
                <FormattedDate value={battle.durationAttacker} second="numeric" minute="numeric" />
              ) : (
                'N/A'
              )}
            </span>
            <span className="icon-clock"> </span>
            <span>
              {battle.durationDefender ? (
                <FormattedDate value={battle.durationDefender} second="numeric" minute="numeric" />
              ) : (
                'N/A'
              )}
            </span>
          </span>
        </div>
        <div className="mars--challenges__col">
          <span className="name">{defender.colonyName}</span>
          {playerID == battle.defender ? (
            <span className={`text ${won ? 'darkgreen' : 'red'}`}>
              {battle.winnerId == battle.defender ? (
                <React.Fragment>
                  <FormattedMessage
                    id={`battles.${won ? 'wins' : 'losts'}`}
                    values={{ amount: 10 }}
                  />
                  <span className="icon-coin"></span>
                </React.Fragment>
              ) : (
                <FormattedMessage
                  id={`battles.${won ? 'won' : 'lost'}`}
                  values={{ name: buildName, level: battle.buildingLevel }}
                />
              )}
            </span>
          ) : null}
        </div>
      </div>
    )
  }

  renderBoxBattle() {
    const { battlesInfo } = this.props
    let wonBattles = battlesInfo.filter((battle) => battle.type == 'BATTLE_WON')
    let lostBattles = battlesInfo.filter((battle) => battle.type != 'BATTLE_WON')

    return (
      <div className="box--border">
        <div className="box--border__canvas">
          <div className="mars--challenges__head success">
            <span className="mars--challenges__head--item">
              <FormattedMessage id="battles.attacker" />
            </span>
            <span className="mars--challenges__head--item">
              <FormattedMessage id="battles.wins" values={{ amount: wonBattles.length }} />
            </span>
            <span className="mars--challenges__head--item">
              <FormattedMessage id="battles.defender" />
            </span>
          </div>
          {wonBattles && wonBattles.length > 0
            ? wonBattles.map((battle, index) => this.renderBattleRow(true, battle, index))
            : null}
          {
            //DISPLAY VOID MESSAGE
            lostBattles.length == 0 && wonBattles.length == 0 ? (
              <div className="mars--challenges__row void">
                <div className="mars--challenges__col">
                  <span className="text">
                    <FormattedMessage id="battles.void" />
                  </span>
                </div>
              </div>
            ) : null
          }
          <div className={`mars--challenges__head failed ${lostBattles.length == 0 ? 'void' : ''}`}>
            <span className="mars--challenges__head--item">
              <FormattedMessage id="battles.attacker" />
            </span>
            <span className="mars--challenges__head--item">
              <FormattedMessage id="battles.losts" values={{ amount: lostBattles.length }} />
            </span>
            <span className="mars--challenges__head--item">
              <FormattedMessage id="battles.defender" />
            </span>
          </div>
          {lostBattles && lostBattles.length > 0
            ? lostBattles.map((battle, index) => this.renderBattleRow(false, battle, index))
            : null}
        </div>
      </div>
    )
  }

  render() {
    const { rivalInfo } = this.props
    return (
      <div className="mars--content challenges">
        <div className="mars--challenges">
          <div className="mars--challenge__results">{this.renderBoxBattle()}</div>
          {rivalInfo ? this.renderCardBattle() : this.renderCardNextPhase()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isTutorialMode: tutorialSelectors.isTutorialMode(state),
  playerID: firebaseSelectors.getOwnPlayerID(state),
})
const mapDispatchToProps = (dispatch) => {
  return {
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
    addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
    getQuestions: bindActionCreators(quizzesActions.getQuestionsList, dispatch),
    getAllDisputes: bindActionCreators(quizzesActions.getAllDisputes, dispatch),
  }
}
BattlesTab.propTypes = {
  battlesInfo: PropTypes.array,
  rivalInfo: PropTypes.object,
  playerID: PropTypes.string,
  playersList: PropTypes.object,
  onClickNextPhase: PropTypes.func,
  startBattle: PropTypes.func,
  addHowlSound: PropTypes.func,
  getQuestions: PropTypes.func,
  getAllDisputes: PropTypes.func,
  isTutorialMode: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(BattlesTab))
